module.exports = __webpack_public_path__ + "static/media/2.0bf3c4fd.jpg";